
/**Модель для описания параметра задачи */
export class TaskParameterModel {
  /**Id параметра */
  Id?: number | string;
  /**Цвет */
  Color?: string;
  /**Имя */
  Name?: string = "";
  /**Данный параметр выбран "По умолчанию" */
  IsDefault?: boolean;
  /**Используется ли параметр */
  InUse?: boolean;
  /**Временный Id для нового параметра */
  TempId?: number = new Date().getTime();
  /**ID очереди */
  QueueId?: string;
  OrganizationGlobalStatus?: TaskParameterModel;
  NamespaceId?: string;
  ImgUrl?: string;
  /**Описание параметра */
  Description?: string;

  constructor(obj?: Partial<TaskParameterModel>) {
    if (obj) Object.assign(this, obj);
  }
}
